import SettingsIcon from "@mui/icons-material/Settings";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import type { Permission } from "@bale-bot/types";
/**
 * Navigation, and the single source of truth for which permission each page
 * needs — `ProtectedRoute` reads the same list to guard direct URL entry.
 */
export const NAV_ITEMS: {
  to: string;
  label: string;
  icon: React.ReactNode;
  permission?: Permission;
}[] = [
  { to: "/", label: "Dashboard", icon: <DashboardIcon /> },
  {
    to: "/settings",
    label: "Bot settings",
    icon: <SettingsIcon />,
    permission: "settings:read",
  },
  {
    to: "/account-managers",
    label: "Account managers",
    icon: <SupportAgentIcon />,
    permission: "settings:read",
  },
  {
    to: "/users",
    label: "Users",
    icon: <PeopleIcon />,
    permission: "users:manage",
  },
  {
    to: "/analytics",
    label: "Analytics",
    icon: <BarChartIcon />,
    permission: "analytics:read",
  },
];
